"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var RemixClerkProvider_exports = {};
__export(RemixClerkProvider_exports, {
  ClerkProvider: () => ClerkProvider
});
module.exports = __toCommonJS(RemixClerkProvider_exports);
var import_clerk_react = require("@clerk/clerk-react");
var import_react = __toESM(require("react"));
var import_utils = require("../utils");
var import_RemixOptionsContext = require("./RemixOptionsContext");
var import_useAwaitableNavigate = require("./useAwaitableNavigate");
__reExport(RemixClerkProvider_exports, require("@clerk/clerk-react"), module.exports);
const SDK_METADATA = {
  name: "@clerk/remix",
  version: "4.4.24"
};
const awaitableNavigateRef = { current: void 0 };
function ClerkProvider({ children, ...rest }) {
  const awaitableNavigate = (0, import_useAwaitableNavigate.useAwaitableNavigate)();
  const isSpaMode = (0, import_utils.inSpaMode)();
  import_react.default.useEffect(() => {
    awaitableNavigateRef.current = awaitableNavigate;
  }, [awaitableNavigate]);
  const { clerkState, ...restProps } = rest;
  import_clerk_react.ClerkProvider.displayName = "ReactClerkProvider";
  if (!isSpaMode) {
    (0, import_utils.assertValidClerkState)(clerkState);
  }
  const {
    __clerk_ssr_state,
    __publishableKey,
    __proxyUrl,
    __domain,
    __isSatellite,
    __clerk_debug,
    __signInUrl,
    __signUpUrl,
    __afterSignInUrl,
    __afterSignUpUrl,
    __signInForceRedirectUrl,
    __signUpForceRedirectUrl,
    __signInFallbackRedirectUrl,
    __signUpFallbackRedirectUrl,
    __clerkJSUrl,
    __clerkJSVersion,
    __telemetryDisabled,
    __telemetryDebug
  } = (clerkState == null ? void 0 : clerkState.__internal_clerk_state) || {};
  import_react.default.useEffect(() => {
    if (!isSpaMode) {
      (0, import_utils.warnForSsr)(clerkState);
    }
  }, []);
  import_react.default.useEffect(() => {
    window.__clerk_debug = __clerk_debug;
  }, []);
  const mergedProps = {
    publishableKey: __publishableKey,
    proxyUrl: __proxyUrl,
    domain: __domain,
    isSatellite: __isSatellite,
    signInUrl: __signInUrl,
    signUpUrl: __signUpUrl,
    afterSignInUrl: __afterSignInUrl,
    afterSignUpUrl: __afterSignUpUrl,
    signInForceRedirectUrl: __signInForceRedirectUrl,
    signUpForceRedirectUrl: __signUpForceRedirectUrl,
    signInFallbackRedirectUrl: __signInFallbackRedirectUrl,
    signUpFallbackRedirectUrl: __signUpFallbackRedirectUrl,
    clerkJSUrl: __clerkJSUrl,
    clerkJSVersion: __clerkJSVersion,
    telemetry: {
      disabled: __telemetryDisabled,
      debug: __telemetryDebug
    }
  };
  return /* @__PURE__ */ import_react.default.createElement(import_RemixOptionsContext.ClerkRemixOptionsProvider, { options: mergedProps }, /* @__PURE__ */ import_react.default.createElement(
    import_clerk_react.ClerkProvider,
    {
      routerPush: (to) => {
        var _a;
        return (_a = awaitableNavigateRef.current) == null ? void 0 : _a.call(awaitableNavigateRef, to);
      },
      routerReplace: (to) => {
        var _a;
        return (_a = awaitableNavigateRef.current) == null ? void 0 : _a.call(awaitableNavigateRef, to, { replace: true });
      },
      initialState: __clerk_ssr_state,
      sdkMetadata: SDK_METADATA,
      ...mergedProps,
      ...restProps
    },
    children
  ));
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ClerkProvider,
  ...require("@clerk/clerk-react")
});
//# sourceMappingURL=RemixClerkProvider.js.map